export function PrivacyPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
      <h1 className="text-xl font-bold text-foreground">
        Privacyverklaring Mijn KUVO Woerden
      </h1>
      <p className="mt-1 text-sm text-muted-foreground">Versie: 9 juni 2026</p>

      <div className="mt-8 space-y-8 text-sm leading-7 text-foreground">
        <p>
          Deze privacyverklaring heeft betrekking op <strong>Mijn KUVO Woerden</strong> (hierna:{" "}
          <em>het portaal</em>), de webapplicatie waarmee basisscholen in de regio Woerden hun
          schoolgegevens aanleveren ten behoeve van de planning van cultuureducatieprogramma&apos;s.
          Het portaal wordt beheerd door <strong>Stichting Kunstzinnige Vorming (KUVO)</strong> uit
          Woerden (hierna: <strong>KUVO</strong>).
        </p>
        <p>
          KUVO vindt het belangrijk dat zorgvuldig wordt omgegaan met persoonsgegevens. Hieronder
          leggen wij uit welke gegevens wij via het portaal verzamelen, waarom wij dat doen, hoe
          lang wij ze bewaren en welke rechten u heeft.
        </p>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            1. Verwerkingsverantwoordelijke
          </h2>
          <div className="mt-2">
            <p>
              <strong>Stichting Kunstzinnige Vorming (KUVO)</strong>
            </p>
            <p>Wilhelminaweg 77, 3441 XB Woerden</p>
            <p>
              E-mail: <strong>carole@kuvowoerden.nl</strong>
            </p>
            <p>KvK-nummer: 30209405</p>
          </div>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            2. Welke gegevens verzamelen wij via het portaal?
          </h2>
          <p className="mt-2">
            Het portaal verzamelt uitsluitend gegevens die nodig zijn voor het plannen en
            coördineren van cultuureducatie-activiteiten. Het gaat om:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>
              <strong>Contactgegevens</strong>: namen, e-mailadressen en telefoonnummers van
              schoolcontactpersonen (zoals leerkrachten, intern cultuurcoördinatoren of
              directieleden);
            </li>
            <li>
              <strong>Groepsinformatie</strong>: groepsnamen, leerjaren en aantallen leerlingen per
              groep;
            </li>
            <li>
              <strong>Beschikbaarheid</strong>: dagen, periodes of dagdelen waarop de school niet
              beschikbaar is voor bezoeken;
            </li>
            <li>
              <strong>Inloggegevens</strong>: e-mailadres en sessiegegevens voor toegangsbeheer.
            </li>
          </ul>
          <p className="mt-2">
            KUVO vraagt via het portaal geen namen van individuele leerlingen, geen BSN-nummers en
            geen bijzondere persoonsgegevens (zoals medische informatie).
          </p>
          <p className="mt-2">
            <strong>Automatisch opslaan.</strong> Wat u in het portaal invult, wordt automatisch
            opgeslagen terwijl u werkt. Wanneer u uw gegevens
            aanlevert, bewaren wij daarvan een vaste versie, zodat KUVO weet welke gegevens
            officieel zijn aangeleverd.
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            3. Waarvoor gebruiken wij deze gegevens?
          </h2>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>
              het plannen, roosteren en coördineren van cultuureducatieprogramma&apos;s voor
              basisscholen in de regio Woerden;
            </li>
            <li>
              het afstemmen van activiteiten met scholen, leerkrachten en culturele aanbieders;
            </li>
            <li>het actueel houden van school- en contactgegevens;</li>
            <li>het veilig en betrouwbaar laten functioneren van het portaal.</li>
          </ul>
          <p className="mt-2">
            De gegevens worden niet gebruikt voor commerciële doeleinden, niet verkocht aan derden
            en niet ingezet voor marketing of profilering.
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            4. Grondslag voor verwerking
          </h2>
          <p className="mt-2">KUVO verwerkt persoonsgegevens op basis van:</p>
          <ul className="mt-2 list-disc space-y-2 pl-5">
            <li>
              <strong>Gerechtvaardigd belang</strong> (art. 6 lid 1 sub f AVG): de verwerking is
              noodzakelijk voor het organiseren van cultuureducatie voor scholen. Zonder deze
              gegevens kan KUVO de programma&apos;s niet plannen.
            </li>
            <li>
              <strong>Uitvoering van een overeenkomst</strong> (art. 6 lid 1 sub b AVG): scholen
              nemen deel aan het KUVO-programma en leveren hiervoor gegevens aan via het portaal.
            </li>
          </ul>
          <p className="mt-2">
            Bij het eerste inloggen bevestigt de gebruiker kennis te hebben genomen van deze
            privacyverklaring. Dit is een kennisgeving, geen toestemming: de verwerking berust op
            het gerechtvaardigd belang hierboven. Waar verwerking op een andere grondslag
            plaatsvindt, zal KUVO dit apart vermelden.
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            5. Wie heeft toegang tot de gegevens?
          </h2>
          <p className="mt-2">
            De gegevens zijn uitsluitend toegankelijk voor:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>
              medewerkers en coördinatoren van KUVO, voor planning en administratie;
            </li>
            <li>
              de school zelf, die via het portaal de eigen gegevens kan inzien en aanpassen;
            </li>
            <li>
              culturele aanbieders of uitvoerende partners, uitsluitend voor zover nodig voor de
              uitvoering van een activiteit (bijvoorbeeld groepsnaam en leerlingaantallen);
            </li>
            <li>
              TechnoHub Woerden (KvK 30218107): geeft een school via het portaal aan
              interesse te hebben in een TechnoHub-workshop, dan deelt KUVO de daarvoor benodigde
              gegevens, zoals de betrokken groepen, leerlingaantallen en een contactpersoon, met
              TechnoHub Woerden. TechnoHub Woerden organiseert en plant deze workshops zelf;
            </li>
            <li>
              de hostingprovider van het portaal, in het kader van technisch beheer.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            6. Bewaartermijnen
          </h2>
          <p className="mt-2">
            KUVO bewaart gegevens niet langer dan nodig. In de praktijk:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>
              schoolgegevens die via het portaal worden aangeleverd, worden bewaard voor de duur van
              het betreffende schooljaar en de voorbereiding van het volgende schooljaar;
            </li>
            <li>
              contactgegevens blijven beschikbaar zolang de contactpersoon actief is bij de school;
            </li>
            <li>
              portaalgegevens worden in beginsel maximaal twee schooljaren na afloop bewaard.
            </li>
          </ul>
          <p className="mt-2">
            Verouderde gegevens worden periodiek opgeschoond, tenzij een wettelijke bewaarplicht van
            toepassing is.
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            7. Beveiliging
          </h2>
          <p className="mt-2">
            KUVO neemt passende technische en organisatorische maatregelen om persoonsgegevens te
            beschermen:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>het portaal is alleen toegankelijk na inloggen via een beveiligde koppeling;</li>
            <li>alle verbindingen verlopen via versleuteld verkeer (HTTPS);</li>
            <li>toegang is beperkt tot bevoegde gebruikers op basis van hun rol;</li>
            <li>
              het portaal wordt gehost binnen de Europese Unie.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            8. Uw rechten
          </h2>
          <p className="mt-2">
            Op grond van de AVG heeft u het recht om:
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>uw persoonsgegevens in te zien;</li>
            <li>onjuiste gegevens te laten corrigeren;</li>
            <li>gegevens te laten verwijderen;</li>
            <li>de verwerking te laten beperken;</li>
            <li>bezwaar te maken tegen verwerking op basis van gerechtvaardigd belang;</li>
            <li>uw gegevens in een gangbaar formaat te ontvangen (dataportabiliteit).</li>
          </ul>
          <p className="mt-2">
            U kunt hiervoor contact opnemen via <strong>carole@kuvowoerden.nl</strong>. KUVO reageert
            binnen één maand.
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            9. Klachten
          </h2>
          <p className="mt-2">
            Heeft u een klacht over hoe KUVO met uw gegevens omgaat? Neem bij voorkeur eerst contact
            met ons op. Daarnaast kunt u een klacht indienen bij de{" "}
            <a
              href="https://www.autoriteitpersoonsgegevens.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary hover:underline"
            >
              Autoriteit Persoonsgegevens
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-base font-semibold text-foreground">
            10. Wijzigingen
          </h2>
          <p className="mt-2">
            KUVO kan deze privacyverklaring aanpassen wanneer de werkwijze, het portaal of de
            wetgeving verandert. De meest recente versie is altijd beschikbaar via het portaal.
          </p>
        </section>
      </div>
    </div>
  );
}
